/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_ResetsInputs */

const en_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resets ${i?.date}`)
};

const de_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zurücksetzung am ${i?.date}`)
};

const fr_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Réinitialisation le ${i?.date}`)
};

const es_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se reinicia el ${i?.date}`)
};

const it_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reset ${i?.date}`)
};

const nl_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wordt gereset op ${i?.date}`)
};

const pl_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resetowanie ${i?.date}`)
};

const fi_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palautukset ${i?.date}`)
};

const da_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nulstille ${i?.date}`)
};

const sv_settings_resets = /** @type {(inputs: Settings_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Återställningar ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Resets {date}" |
*
* @param {Settings_ResetsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_resets = /** @type {((inputs: Settings_ResetsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_ResetsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_resets(inputs)
	if (locale === "fr") return fr_settings_resets(inputs)
	if (locale === "es") return es_settings_resets(inputs)
	if (locale === "it") return it_settings_resets(inputs)
	if (locale === "nl") return nl_settings_resets(inputs)
	if (locale === "pl") return pl_settings_resets(inputs)
	if (locale === "fi") return fi_settings_resets(inputs)
	if (locale === "da") return da_settings_resets(inputs)
	if (locale === "sv") return sv_settings_resets(inputs)
	return en_settings_resets(inputs)
});